import { useAppMutation } from '@/hooks/api';
import { API_ROUTES } from '@/constants/api-routes';
import mutationKeys from '@/constants/mutationKeys';
import { MutateOptions } from 'react-query';

export const useRenameTemplateMutation = (
  templateId: string,
  options: MutateOptions<{ templateName: string }, unknown, unknown, unknown>,
) => {
  return useAppMutation<{
    templateName: string;
  }>({
    routeName: API_ROUTES.RENAME_TEMPLATE.replace(':templateId', templateId),
    mutationKey: [mutationKeys.TEMPLATE_GALLERY_RENAME_TEMPLATE],
    method: 'POST',
    options,
  });
};